import { OrderingProviderFieldsFragment } from 'src/types';

/**
 * Mock ordering providers for testing the ordering provider autocomplete.
 * Contains 30 providers with varied data for comprehensive testing.
 */
export const mockOrderingProviders: OrderingProviderFieldsFragment[] = [
  {
    id: 'provider-1',
    siteName: 'Boston Medical Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-0101',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'John',
      lastName: 'Smith',
      npi: '1234567890',
      email: 'john.smith@bostonmedical.com',
    },
  },
  {
    id: 'provider-2',
    siteName: 'Cambridge Health Associates',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-0201',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Sarah',
      lastName: 'Johnson',
      npi: '0987654321',
      email: 'sarah.johnson@cambridgehealth.com',
    },
  },
  {
    id: 'provider-3',
    siteName: 'Somerville Family Practice',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-0301',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Michael',
      lastName: 'Chen',
      npi: '1122334455',
      email: 'michael.chen@somervillefp.com',
    },
  },
  {
    id: 'provider-4',
    siteName: 'Brookline Medical Group',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Emily',
      lastName: 'Davis',
      npi: '5566778899',
      email: 'emily.davis@brooklinemedical.com',
    },
  },
  {
    id: 'provider-5',
    siteName: 'Newton-Wellesley Clinic',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-0501',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'David',
      lastName: 'Martinez',
      npi: '9988776655',
      email: 'david.martinez@newtonwellesley.com',
    },
  },
  {
    id: 'provider-6',
    siteName: 'Quincy Healthcare Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-0601',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Jennifer',
      lastName: 'Wilson',
      npi: '1231231234',
      email: 'jennifer.wilson@quincyhc.com',
    },
  },
  {
    id: 'provider-7',
    siteName: 'Waltham Medical Associates',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Robert',
      lastName: 'Anderson',
      npi: '4564564567',
      email: 'robert.anderson@walthammedical.com',
    },
  },
  {
    id: 'provider-8',
    siteName: 'Lexington Health Partners',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-0801',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Lisa',
      lastName: 'Thompson',
      npi: '7897897890',
      email: 'lisa.thompson@lexingtonhealth.com',
    },
  },
  {
    id: 'provider-9',
    siteName: 'Arlington Family Medicine',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-0901',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'James',
      lastName: 'Brown',
      npi: '3213213210',
      email: 'james.brown@arlingtonfm.com',
    },
  },
  {
    id: 'provider-10',
    siteName: 'Medford Clinic',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Patricia',
      lastName: 'Garcia',
      npi: '6546546540',
      email: 'patricia.garcia@medfordclinic.com',
    },
  },
  {
    id: 'provider-11',
    siteName: 'Malden Medical Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-1101',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Christopher',
      lastName: 'Lee',
      npi: '9879879870',
      email: 'christopher.lee@maldenmedical.com',
    },
  },
  {
    id: 'provider-12',
    siteName: 'Revere Health Services',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-1201',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Nancy',
      lastName: 'White',
      npi: '1471471470',
      email: 'nancy.white@reverehealth.com',
    },
  },
  {
    id: 'provider-13',
    siteName: 'Watertown Medical Group',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Daniel',
      lastName: 'Rodriguez',
      npi: '2582582580',
      email: 'daniel.rodriguez@watertownmedical.com',
    },
  },
  {
    id: 'provider-14',
    siteName: 'Belmont Family Practice',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-1401',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Karen',
      lastName: 'Taylor',
      npi: '3693693690',
      email: 'karen.taylor@belmontfp.com',
    },
  },
  {
    id: 'provider-15',
    siteName: 'Needham Healthcare',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-1501',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Steven',
      lastName: 'Harris',
      npi: '7417417410',
      email: 'steven.harris@needhamhc.com',
    },
  },
  {
    id: 'provider-16',
    siteName: 'Dedham Medical Associates',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Michelle',
      lastName: 'Clark',
      npi: '8528528520',
      email: 'michelle.clark@dedhammedical.com',
    },
  },
  {
    id: 'provider-17',
    siteName: 'Milton Health Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '617-555-1701',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Brian',
      lastName: 'Lewis',
      npi: '9639639630',
      email: 'brian.lewis@miltonhealth.com',
    },
  },
  {
    id: 'provider-18',
    siteName: 'Framingham Medical Group',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '508-555-1801',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Elizabeth',
      lastName: 'Walker',
      npi: '1591591590',
      email: 'elizabeth.walker@framinghammedical.com',
    },
  },
  {
    id: 'provider-19',
    siteName: 'Natick Family Medicine',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Kevin',
      lastName: 'Hall',
      npi: '7537537530',
      email: 'kevin.hall@natickfm.com',
    },
  },
  {
    id: 'provider-20',
    siteName: 'Wellesley Medical Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2001',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Amanda',
      lastName: 'Young',
      npi: '3573573570',
      email: 'amanda.young@wellesleymedical.com',
    },
  },
  {
    id: 'provider-21',
    siteName: 'Burlington Health Associates',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2101',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Thomas',
      lastName: 'King',
      npi: '9519519510',
      email: 'thomas.king@burlingtonhealth.com',
    },
  },
  {
    id: 'provider-22',
    siteName: 'Woburn Medical Group',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Donna',
      lastName: 'Wright',
      npi: '1571571570',
      email: 'donna.wright@woburnmedical.com',
    },
  },
  {
    id: 'provider-23',
    siteName: 'Reading Family Practice',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2301',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Paul',
      lastName: 'Lopez',
      npi: '7517517510',
      email: 'paul.lopez@readingfp.com',
    },
  },
  {
    id: 'provider-24',
    siteName: 'Stoneham Health Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2401',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Carol',
      lastName: 'Hill',
      npi: '3513513510',
      email: 'carol.hill@stonehamhealth.com',
    },
  },
  {
    id: 'provider-25',
    siteName: 'Winchester Medical Associates',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Mark',
      lastName: 'Scott',
      npi: '9539539530',
      email: 'mark.scott@winchestermedical.com',
    },
  },
  {
    id: 'provider-26',
    siteName: 'Melrose Family Medicine',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2601',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Sandra',
      lastName: 'Green',
      npi: '1531531530',
      email: 'sandra.green@melrosefm.com',
    },
  },
  {
    id: 'provider-27',
    siteName: 'Wakefield Health Partners',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2701',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'George',
      lastName: 'Adams',
      npi: '7527527520',
      email: 'george.adams@wakefieldhealth.com',
    },
  },
  {
    id: 'provider-28',
    siteName: 'Saugus Medical Group',
    siteFaxRegionCode: null,
    siteFaxNumber: null,
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Betty',
      lastName: 'Baker',
      npi: '3563563560',
      email: 'betty.baker@saugusmedical.com',
    },
  },
  {
    id: 'provider-29',
    siteName: 'Lynn Community Health',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '781-555-2901',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Edward',
      lastName: 'Nelson',
      npi: '9579579570',
      email: 'edward.nelson@lynncommunity.com',
    },
  },
  {
    id: 'provider-30',
    siteName: 'Peabody Healthcare Center',
    siteFaxRegionCode: 'US',
    siteFaxNumber: '978-555-3001',
    receiveReportsByFax: false,
    orderingPhysician: {
      firstName: 'Dorothy',
      lastName: 'Carter',
      npi: '1511511510',
      email: 'dorothy.carter@peabodyhc.com',
    },
  },
];
